import React, { FC, ReactNode } from "react";
import classNames from "classnames/dedupe";
import { ClearSmallIcon } from "../../../../icons";
import { TThemeVariant, useTheme } from "../../../Utility/ThemeProvider";

export interface IClearAllProps {
  text?: ReactNode;
  theme?: TThemeVariant;
  onClear?(): void;
}

export const ClearAll: FC<IClearAllProps> = ({
  theme: propsTheme,
  text = "Clear All",
  onClear,
}) => {
  const theme = useTheme(propsTheme);
  const handleClick = () => onClear && onClear();
  return (
    <div
      className={classNames("dropdown-menu-footer", {
        "text-color-white": theme === "dark",
      })}
      data-testid="clear-all-footer"
      onClick={handleClick}
    >
      <span className="dropdown-menu-footer__clear">{text}</span>
      <ClearSmallIcon />
    </div>
  );
};
